import React from "react"
import Layout from "../../components/layout"
import Helmet from "react-helmet"
import bmSignature from "../../../static/images/bm-signature-new-gold.png"

const NominationPageTemplate = ({ data }) => (
  <Layout>
    <Helmet>
      <title>
        Nomination for Best Patisserie in Bangalore in 2026 - Deliciae Cakes
      </title>
      <meta
        name="description"
        content="Nomination for Best Patisserie in Bangalore in 2026 - Deliciae Cakes"
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Nomination for Best Patisserie in Bangalore in 2026 - Deliciae Cakes"
      />
      <meta
        property="og:description"
        content="Nomination for Best Patisserie in Bangalore in 2026 - Deliciae Cakes"
      />
      <meta
        property="og:image"
        content={
          "https://www.deliciaecakes.com/images/homepage/gifting-square.jpg"
        }
      />
      <meta property="twitter:card" content="summary_large_image" />
      <meta
        property="twitter:title"
        content="Nomination for Best Patisserie in Bangalore in 2026 - Deliciae Cakes"
      />
      <meta
        property="twitter:description"
        content="Custom Cakes: Made-to-order custom cakes that make a special occasion a little more meaningful. Order custom cakes online. Home delivery also available."
      />
      <meta
        property="twitter:image"
        content={
          "https://www.deliciaecakes.com/images/homepage/gifting-square.jpg"
        }
      />
    </Helmet>
    <div className={"light-bg"}>
      <div className="container py-5 pb-0" style={{ minHeight: "80vh" }}>
        <div className="row">
          <div className="col-md-12">
            <h1 className={"text-center mb-5"}>Vote for Deliciae</h1>

            <p>
              After having been awarded the Best Patisserie in Mumbai for six
              consecutive years, I am elated to share that Deliciae has been{" "}
              <strong>
                nominated for the Best Patisserie in Bangalore 2026
              </strong>{" "}
              by the Times Food Awards
              <span aria-label="star" role="img">
                ⭐
              </span>
            </p>

            <p>
              Please vote for Deliciae by giving a missed call on{" "}
              <a
                style="text-decoration: underline; font-weight: bold;"
                href="tel:07315187858"
              >
                07315187858
              </a>{" "}
              (Click to call directly)
            </p>

            <img
              src={bmSignature}
              alt="Bunty Mahajan"
              style={{ width: "200px" }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

const NominationPage = (result) => {
  return <NominationPageTemplate data={result.data} />
}

export default NominationPage
